export const initialState = {
  availableRecipes: [],
  page: 1,
  isLoading: false,
  error: null,
  total: null,
};
